import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Card } from '../../../components/Card';
import { IsOpen } from '../../../components/Icon';
import { Modal } from '../../../components/Modal';
import { FormField } from '../../../components/FormFields';
import { Loader } from '../../../components/Loader';
import { COLOR_SECONDARY_1 } from '../../../vars';
import { setVehicleProperty, deleteVehicleProperty } from '../actions';
import { selectWorks } from '../../Api/selectors';
import { REQUEST_VEHICLE_PROPERTIES, REQUEST_VEHICLE_PROPERTY_UPDATE } from '../constants';
import _, { isDate } from 'lodash';
import { Input } from '../../../components/Input';
import dayjs from 'dayjs';
import cn from 'classnames';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import styles from './cardHooicardtakeout.module.css';
import { getDate } from '../helpers';

const Container = styled.div`
  .started {
    margin: 12px 0;
    font-weight: 600;
  }
  .sub-title {
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    text-align: left;
    width: 100%;
    margin: 12px 0 0;
  }
  .address {
    border: 1px solid #ddd;
    border-radius: 12px;
    padding: 12px;
    margin: 12px;
    .name {
      font-weight: 600;
    }

    &.selected {
      border: 2px solid ${COLOR_SECONDARY_1};
    }
  }
  .dropdown-block {
    min-height: 300px;
  }

  .dropdown {
    min-width: 250px;
  }
`;

const STATE = {
  init: false,
  takeout: false,
  takeout_details: '',
  isOpen: false,
  values: null,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleHooicardtakeoutComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.vehicle.takeout_details) {
      this.setState({ takeout_details: this.props.vehicle.takeout_details });
    }
  }

  onChangeText(evt) {
    this.setState({ takeout_details: evt.target.value });
  }

  handleDeleteTakeout = () => {
    const { deletetakeout, vehicle } = this.props;
    deletetakeout(vehicle.id, () => {
      console.log('Delete takeout callback');
    });
  };

  onTakeOut(n) {
    this.setState({ takeout: false });
    this.props.takeout(n, this.state.takeout_details, this.reset.bind(this));
  }

  reset() {
    this.setState({
      init: false,
      takeout: false,
    });
  }

  render() {
    if (this.props.work)
      return (
        <Modal>
          <HBox center>
            <Loader />
          </HBox>
        </Modal>
      );
    const vehicle = this.props.vehicle;
    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <Container>
          <HBox>
            <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.info.uitslag')}</h2>
            {window.innerWidth <= 768 && (
              <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                <IsOpen />
              </div>
            )}
          </HBox>
          {(this.state.isOpen || window.innerWidth > 768) && (
            <>
              <Button className={styles.button} onClick={() => this.setState({ takeout: true })}>
                {vehicle.task_move_car_for_takeout == 'ok' ? 'Voertuig uitslag afgerond' : 'Voertuig uitslaan'}
              </Button>
              {vehicle.task_move_car_for_takeout == 'ok' && (
                <Button warning onClick={() => {
                  if (window.confirm('Weet u het zeker?')) {
                    this.handleDeleteTakeout();
                  }
                }}>
                  {this.lbl('vehicle.property.task_move_car_for_takeout.delete')}
                </Button>
              )}

              {this.renderModal()}
            </>
          )}
          <span>Afgehaald door: {vehicle.takeout_details}<br /> Uitslagdatum: {getDate(vehicle?.HOOI_uitslag_done_date) }</span>
        </Container>
      </Card>
    );
  }

  renderModal() {
    if (this.state.takeout) return this.renderTakeoutModal();
    if (!this.state.init) return null;
  }

  renderTakeoutModal() {
    return (
      <ModalComponent onClose={this.reset.bind(this)} title="Voertuig uitslaan?">
        <VBox className={styles.containerForm}>
          <label className="form-label">Afgehaald door:</label>
          <input
            className="form-control"
            type="textfield"
            value={this.state.takeout_details}
            onChange={this.onChangeText.bind(this)}
          />
          {['ok'].map(n => (
            <Button onClick={() => this.onTakeOut(n)} key={n}>
              {this.lbl(`vehicle.property.task_move_car_for_takeout.${n}`)}
            </Button>
          ))}
        </VBox>
      </ModalComponent>
    );
  }
}

VehicleHooicardtakeoutComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_VEHICLE_PROPERTIES}-${ownProps.vehicle?.id}`, REQUEST_VEHICLE_PROPERTY_UPDATE]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    takeout(id, takeOutDetails = '', callback) {
      let todaydate = new Date().toISOString();
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'task_move_car_for_takeout', id, callback));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'HOOI_uitslag_done', '1', callback));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'status', '1', callback));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'HOOI_uitslag_done_date', todaydate, callback));
      if (takeOutDetails) {
        dispatch(setVehicleProperty(ownProps.vehicle.id, 'takeout_details', takeOutDetails, callback));
      }
      if (!takeOutDetails) {
        dispatch(deleteVehicleProperty(ownProps.vehicle.id, 'takeout_details', callback));
      }
    },
    deletetakeout() {
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, 'task_move_car_for_takeout'));
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, 'HOOI_uitslag_done'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'status', '0'));
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, 'HOOI_uitslag_done_date'));
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, 'takeout_details'));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleHooicardtakeout = compose(withConnect, withRouter)(VehicleHooicardtakeoutComp);
